module.exports = __webpack_public_path__ + "static/media/c3.b964c0c0.jpg";